
import { defineComponent, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { SoftwareInfoService } from '@/views/dashboard/group/client/terminal-info/software-info/software-info.service'
import InstalledDetail
  from '@/views/dashboard/manage/software-manage/_components/client-view/_component/installed-detail/installed-detail.vue'

export default defineComponent({
  components: {
    InstalledDetail
  },

  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const injector = useReflectiveInjector([SoftwareInfoService])
    const service = injector.get(SoftwareInfoService)

    const isLoading = ref(false)

    return {
      isLoading,
    }
  }
})
